import { formatPhone } from "@/lib/apps/autoleads/phone"
import { cn } from "@/lib/utils"

// A number on a lead is there to be dialled: a `tel:` link hands it to the
// softphone the user has registered on their computer (Aircall, Ringover,
// Teams...) instead of making them retype it. The click never bubbles, since
// most numbers sit inside a card or row that opens something on click.
export function PhoneLink({
  phone,
  className,
}: {
  phone: string
  className?: string
}) {
  return (
    <a
      href={`tel:${phone.replace(/\s/g, "")}`}
      onClick={(event) => event.stopPropagation()}
      className={cn("tabular-nums hover:underline", className)}
    >
      {formatPhone(phone)}
    </a>
  )
}
